import {
  RETRY_DEPOSIT_ACCOUNT_PAYMENT,
  updateDepositAccountPaymentStatus,
} from '../../../../../shared/actions/depositAccount';
import { selectAnalyticsOfferStatus } from '../../../../../shared/selectors/analytics';
import { getPaymentStatus } from '../../../../../shared/services/billingPayments';
import { listenEvent } from '../../../../../shared/utils';
import { trackPaymentCanceled, trackPaymentSuccess, trackPaymentTimeout, trackRetryPaymentClick } from './tracking';
import { IUserService } from '../userService';
import { IApiService } from '../apiService';
import { Store } from 'redux';
import { IAppState } from '../../../../../shared/redux';
import { IHttpApi } from '@cian/http-api';
import { IPlacingTermsApiService } from '../../../publish-terms/apiFactory';
import { EPaymentStatus, TPaymentStatus } from '../../../../../shared/types/reducers/depositAccount';
import {
  EPaymentInitSource,
  EPaymentProvider,
  EPaymentWidgetResultStatus,
  IPaymentWidgetMicrofrontendAPI,
} from '../../../../../shared/types/microfrontends/paymentWidget';

export const cardPaymentService = [
  'apiService',
  'userService',
  'placingTermsApi',
  'store',
  'httpApi',
  function (
    apiService: IApiService,
    userService: IUserService,
    placingTermsApi: IPlacingTermsApiService,
    store: Store<IAppState>,
    httpApi: IHttpApi,
    paymentWidgetMicrofrontend: IPaymentWidgetMicrofrontendAPI,
  ) {
    let paymentStatus: TPaymentStatus;
    let checkInterval: number;
    let failTimeout: number;
    let paymentSum: number;

    const state = store.getState();
    const analyticsOfferStatus = selectAnalyticsOfferStatus(state);

    const clearTimers = () => {
      clearInterval(checkInterval);
      clearTimeout(failTimeout);
    };

    const setPaymentStatus = (status: TPaymentStatus) => {
      paymentStatus = status;

      store.dispatch(updateDepositAccountPaymentStatus(status));
    };

    const updateBalance = async () => {
      const { totalBalance } = await apiService.getUserBalance();

      if (totalBalance !== undefined) {
        const isNotEnoughMoney = totalBalance < placingTermsApi.getTotalPriceAmount();

        userService.setBalance(totalBalance);
        placingTermsApi.setNotEnoughMoney(isNotEnoughMoney);
      }
    };

    const checkPayment = (paymentId: string, provider: EPaymentProvider) => async () => {
      const { status } = await getPaymentStatus({ httpApi, paymentId, provider });

      setPaymentStatus(status);

      if (status === EPaymentStatus.Success) {
        clearTimers();

        updateBalance();

        trackPaymentSuccess({ analyticsOfferStatus, amount: paymentSum });
      } else if (status === EPaymentStatus.Fail) {
        trackPaymentCanceled(analyticsOfferStatus);
      }
    };

    const runCheckPaymentState = (paymentId: string, provider: EPaymentProvider) => {
      clearTimers();

      setPaymentStatus(EPaymentStatus.Pending);

      checkInterval = window.setInterval(checkPayment(paymentId, provider), 3000); // 3 секунды

      failTimeout = window.setTimeout(() => {
        clearTimers();

        setPaymentStatus(EPaymentStatus.Fail);

        trackPaymentTimeout(analyticsOfferStatus);
      }, 300000); // 5 минут

      checkPayment(paymentId, provider)();
    };

    const getState = () => paymentStatus;

    const setPaymentSum = (value: number) => {
      paymentSum = value;
    };

    const getPaymentSum = () => paymentSum;

    listenEvent(RETRY_DEPOSIT_ACCOUNT_PAYMENT, async () => {
      trackRetryPaymentClick({ analyticsOfferStatus, amount: paymentSum });

      const result = await paymentWidgetMicrofrontend?.openDepositModal({
        amount: paymentSum,
        paymentInitSource: EPaymentInitSource.AddFormDeposit,
      });

      if (result.status === EPaymentWidgetResultStatus.Success) {
        runCheckPaymentState(result.paymentId, result.provider);
      }
    });

    return {
      runCheckPaymentState,
      getState,
      getPaymentSum,
      setPaymentSum,
    };
  },
];
